import Immutable from 'immutable';

export function formatPrice(price) {
  return Number.parseFloat(price).toFixed(2).replace('.', ',');
}

export function findProductWithId(id, cartItems = Immutable.List()) {
  const product = cartItems.find((item) => item.get('id') === id) || null;
  return product;
}

export function formatCartItemsForAnalytics(cartItems = Immutable.List()) {
  return cartItems.map((item) => {
    return formatCartItemForAnalytics(item);
  }, []).toArray();
}

export function formatCartItemForAnalytics(item = Immutable.Map()) {
  return {
    item_id: item.getIn(['relationships', 'purchased_entity', 'attributes', 'sku'], '-'),
    item_name: item.getIn(['attributes', 'title'], '-'),
    price: item.getIn(['attributes', 'unit_price', 'number']),
    quantity: parseInt(item.getIn(['attributes', 'quantity'], 1)),
  };
}

export function getFormBillingProperties(obj) {
  return Object.fromEntries(
    Object.entries(obj)
      .filter(([key]) => key.startsWith('billing_'))
      .map(([key, value]) => [key.replace('billing_', ''), value]),
  );
}

